import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {RouterModule, ROUTES} from '@angular/router';
import {ConfigService} from "./config.service";

export function configServiceFactory(injector: Injector, configService: ConfigService) {
  return () => {
    return configService.loadConfig();
  }
}

export function configHandlerRoutes(injector: Injector, configService: ConfigService) {
  return configService.settings;
}

@NgModule({
  imports: [RouterModule.forRoot([])],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [Injector, ConfigService],
      multi: true
    },
    {
      provide: ROUTES,
      useFactory: configHandlerRoutes,
      deps: [Injector, ConfigService],
      multi: true
    },
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
